import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class DebitFormDataService {
  data:any
  constructor(private dataService: DataService) { }

  save(debitFormDetails) {
    return this.dataService.post('/api/debitForm/SaveDebitForm', debitFormDetails);
  }
  serviceRequestSave(debitFormDetails: string) {
    return this.dataService.post('/api/debitForm/SaveChangeRequestDebitForm', debitFormDetails);
  }

  getDebitFormPDF(debitFormId: number) {
    return this.dataService.getReport('/api/debitForm/GenerateDebitFormReport/' + debitFormId);
  };
  getServiceDebitFormPDF(debitFormId: number) {
    return this.dataService.getReport('/api/debitForm/GenerateServiceDebitFormReport/' + debitFormId);
  };

  downloadDebitFormPDF(debitFormId: number) {
    return this.dataService.getReport('/api/debitForm/DownloadDebitFormReport/' + debitFormId);
  };
  downloadServiceDebitFormPDF(debitFormId) {
    return this.dataService.getRecord('/api/debitForm/DownloadServiceDebitFormReport/' + debitFormId);
  };

  getDebitFormDetail(ApplicationId: number) {

    return this.dataService.getRecord('/api/debitForm/getDebitFormDetail/' + ApplicationId);
  };

  getSnapScanQRCodeResponse(searchQuery: string) {
    return this.dataService.post('/api/debitForm/getSnapScanQRCodeResponse', searchQuery);
  };

  saveSnapScanQRCodeInitialize(searchQuery: string) {
    return this.dataService.post('/api/debitForm/saveSnapScanQRCodeInitialize', searchQuery);
  };

  getAllSnapScanPayment() {
    return this.dataService.getRecord('/api/debitForm/getAllSnapScanPayment');
  };

  saveDebitFormDocument(debitFormDetails: string) {
    return this.dataService.post('/api/debitForm/SaveDebitFormDocument', debitFormDetails);
  };
  saveServiceChangeDocument(debitFormDetails: string) {
    return this.dataService.post('/api/debitForm/SaveServiceChangeDocument', debitFormDetails);
  };
  getBankList() {
    return this.dataService.getRecord('/api/debitForm/getBankList');
  };

  getDebitFormDetailById(id: number) {

    return this.dataService.getRecord('/api/debitForm/getDebitFormDetailById/' + id);
  };
  updateDebitFormSendNotificationEmail(debitFormDetails: string) {
    return this.dataService.post('/api/debitForm/UpdateDebitFormSendNotificationEmail', debitFormDetails);
  };
  ServiceChangeRequestUpdate(serviceChangeRequestId: number) {
    return this.dataService.getRecord('/api/ServiceChangeRequest/ServiceChangeRequestUpdate/?serviceChangeRequestId=' + serviceChangeRequestId);
  };
  saveCOSDebitOrder(debitFormDetails: string) {
    return this.dataService.post('/api/debitForm/SaveDebitForm', debitFormDetails);
  }
  savedebitFormFromAdmin(debitFormDetails: string) {
    return this.dataService.post('/api/debitForm/savedebitFormFromAdmin', debitFormDetails);
  }
  getBankingDetailsProof() {
    return this.dataService.getRecord('/api/debitForm/getBankingDetailsProof');
  };
  saveBankingDetailsProof(userId: number) {
    return this.dataService.post('/api/debitForm/saveBankingDetailsProof/' + userId, this.data);
  };
  updateUserBillingBanking(debitFormDetails: string) {
    return this.dataService.post('/api/Report/updateUserBillingBanking', debitFormDetails);
  }
  //getProductCostForDebitForm  (productId) {
  //    return this.dataService.getRecord('/api/debitFrom/GetProductCostForDebitForm', productId);
  //}
  checkIsRestrictedDebitForm(debitFormDetails: string) {
    return this.dataService.post('/api/debitForm/CheckIsRestrictedDebitForm', debitFormDetails);
  }

  CheckIsRedirectBalancePayment() {
    return this.dataService.getRecord('/api/debitForm/CheckIsRedirectBalancePayment');
  }
  getDebitformByApplicationId(id: number) {

    return this.dataService.getRecord('/api/debitForm/getDebitformByApplicationId/' + id);
  };
  saveDebitFormAfterTermsAndCondition(debitFormDetails: string) {
    return this.dataService.post('/api/debitForm/SaveDebitFormAfterTermsAndCondition', debitFormDetails);
  }
}
